import { useInitialiseJobStatus } from "@lib/jobs/useJobStatus";
import { JobStatusContext } from "@lib/jobs/JobStatusContext";

export default function JobsProvider({ children }) {
  const { jobs, addJob, updateJob, removeJobs } = useInitialiseJobStatus();

  return (
    <JobStatusContext.Provider value={{ jobs, addJob, updateJob, removeJobs }}>
      {children}
    </JobStatusContext.Provider>
  );
}
